import { render, staticRenderFns } from "./CatalogStories.vue?vue&type=template&id=48e1d5a0&scoped=true&"
import script from "./CatalogStories.vue?vue&type=script&lang=js&"
export * from "./CatalogStories.vue?vue&type=script&lang=js&"
import style0 from "./CatalogStories.vue?vue&type=style&index=0&id=48e1d5a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e1d5a0",
  null
  
)

export default component.exports